export { DMS_MODULE } from '../../constants';
export const CRUMB_LABEL_KEY = 'edtKodySAGA2';
export const NAME = 'KodyCV';
